module.exports = __webpack_public_path__ + "static/media/vacation-with-friends.c8457c63.png";